<ng-container *ngIf="form">
	<div class="language-header">
		<stages-tabs [wrap]="true" *ngIf="currentLanguage$">
			<stages-tab-no-route
				*ngFor="let language of translation.languages"
				[active]="isTabActive(language.id!)"
				(activate)="setCurrentLanguage(language.id!)"
				[warning]="hasWarning(form, language.id!)"
			>
				<h5 [translate]="language.name"></h5>
			</stages-tab-no-route>
		</stages-tabs>
	</div>

	<ng-container *ngFor="let language of translation.languages">
		<ng-container *ngIf="language.id === currentLanguage">
			<stages-input
				*ngIf="getNameInput(currentLanguage)"
				[form]="getFormGroupByLanguage(currentLanguage)"
				[input]="getNameInput(currentLanguage)!"
			/>
			<stages-input
				*ngIf="getDescriptionInput(currentLanguage) !== undefined"
				[form]="getFormGroupByLanguage(currentLanguage)"
				[input]="getDescriptionInput(currentLanguage)!"
			/>
			<ng-container *ngFor="let customAttributeIdent of translation.customRichTextAttributeIdents">
				<stages-input
					*ngIf="getCustomAttributeInput(customAttributeIdent, currentLanguage) !== undefined"
					[form]="getFormGroupByLanguage(currentLanguage)"
					[input]="getCustomAttributeInput(customAttributeIdent, currentLanguage)!"
				/>
			</ng-container>
		</ng-container>
	</ng-container>

	<ng-container *ngIf="isTranslatorConfigured$ | async">
		<ng-container *ngIf="!isSourceLanguage">
			<div class="translate-button">
				<stages-split-button *ngIf="this.isMobileView" [items]="this.mobileMenuItems"></stages-split-button>
				<stages-button
					*ngIf="!this.isMobileView"
					[title]="'translate.button'"
					[buttonTranslateParams]="{ ARG0: (getCurrentLanguageName() | translate) }"
					[showAsPlainText]="true"
					[buttonCSS]="'sm'"
					[showLoadingSpin]="loading"
					(clicked)="generateTranslation()"
				/>
				<p class="error" *ngIf="systemMessage$ | async as systemError">
					<span *ngIf="systemError.isLanguageProperty" [translate]="systemError.message"></span>
					<span *ngIf="!systemError.isLanguageProperty">{{ systemError.message }}</span>
				</p>
			</div>
			<footer [ngClass]="{ 'include-padding-top': this.isMobileView }">
				<stages-disclaimer-main [hideALittle]="true" [message]="'ai.widget.legal'"></stages-disclaimer-main>
			</footer>
		</ng-container>
	</ng-container>
</ng-container>
